module.exports = __webpack_public_path__ + "img/matias_penhos.993e42aa.png";